import { useNavigate } from 'react-router'

import PlusIcon from '@/assets/icons/icon-plus.svg'
import { Button } from '@/components/ui/button.tsx'
import { classNames } from '@/utils/helpers'

interface HeaderButtonProps {
  onPress?: () => void
  className?: string
  containerClassName?: string
}

export const CreateMessageButton = ({
  onPress,
  className,
  containerClassName,
}: HeaderButtonProps) => {
  const redirect = useNavigate()

  const redirectOnCreatePage = () => {
    redirect('create')
  }

  const onCreateMessagePress = onPress || redirectOnCreatePage

  return (
    <div className={classNames('flex items-center gap-2', containerClassName)}>
      <Button
        onClick={onCreateMessagePress}
        className="gap-1"
      >
        <PlusIcon className="fill-neutral-default" />
        <a className={className}>Create Message</a>
      </Button>
    </div>
  )
}
